module.exports = __webpack_public_path__ + "static/saltmarsh-region-annotated-eee54292d37d46f515fb418eb078a682.png";